// Adaptive Mode submodes. Single source of truth so Onboarding + Profile can
// both render the picker without drifting.
//
// Cycle-aware, perimenopause, and older-adult submodes are hidden until
// each has first-class program-adjustment support. See memory/MASTER_BACKLOG.md
// backlog.

export const ADAPTIVE_SUBMODES = [
  { id: 'chronic-pain', label: 'Chronic pain', blurb: 'Persistent pain, autoimmune, fibromyalgia, post-surgical' },
  { id: 'amputee', label: 'Amputee / prosthesis', blurb: 'Upper or lower-limb amputation, on-prosthesis and off' },
];
